const faq = [
  {
    question: "What is Billion Towers?",
    answer: "Billion Towers is an innovative investment project dedicated to real estate. We allow clients to invest as little as $10 in investment properties, with the aim of building up regular income and/or savings."
  },
  {
    question: "I want to buy NFTs, what payment methods are accepted?",
    answer: "You can use various payment methods such as Metamask, Phantom wallet, OKX wallet, Trust wallet, etc."
  },
  {
    question: "What is the marketplace, or secondary market?",
    answer: "The Billion Towers Marketplace is our platform that allows Billion Towers community members to buy and sell NFTs among themselves. It is the equivalent of a secondary market where investors can buy and sell NFTs among themselves. We may also cooperate with other marketplaces to allow anyone to choose their preferred marketplace."
  },
  {
    question: "I sell or buy NFTs during the month. Who receives the rental income for the current month?",
    answer: "The rental income is paid to the investor who owns the NFTs on the day the royalties are paid."
  },
  {
    question: "Are transactions on the platform secure?",
    answer: "Billion Towers uses the most advanced technical means to ensure the confidentiality and security of transactions on the platform."
  },
  {
    question: "How do I get started with investing?",
    answer: "Getting started is simple! Just connect your wallet, browse our available properties, and invest with as little as $10. You'll receive monthly returns based on your investment share."
  },
  {
    question: "What are the minimum and maximum investment amounts?",
    answer: "The minimum investment is $10, and there's no maximum limit. You can invest as much as you're comfortable with in any property."
  },
  {
    question: "How often do I receive returns?",
    answer: "Returns are distributed monthly. You'll receive your share of rental income directly to your connected wallet on the same day each month."
  }
];

export default faq;

